var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import Calendar from "rc-calendar";
import Picker from "rc-calendar/lib/Picker";
import Input from "../Input";
import moment from "moment";
import "moment/locale/en-gb";
var now = moment();
now.utcOffset(0);
export var DatePicker = function (_a) {
    var value = _a.value, label = _a.label, name = _a.name, open = _a.open, otherProps = __rest(_a, ["value", "label", "name", "open"]);
    var _b = useState(value ? moment(value) : ""), selectedValue = _b[0], setSelectedValue = _b[1];
    var calendar = _jsx(Calendar, __assign({ defaultValue: now }, otherProps));
    return (_jsx(React.Fragment, { children: _jsx(Picker, __assign({ animation: "slide-up", value: selectedValue, disabled: false, calendar: calendar, onChange: function (newDate) {
                setSelectedValue(moment(newDate));
            }, open: open }, { children: function () {
                return (_jsx(Input, { name: name, label: label, value: selectedValue ? moment(selectedValue).format("YYYY-MM-DD") : "" }));
            } })) }));
};
export var RangePicker = "./RangeDatePicker";
export default DatePicker;
